// The two modals document rows open most: the PDF preview and the
// click-to-sign confirmation.
import type { Dispatch } from "redux";
import {
  setModalxComponent,
  setModalxComponentProps,
  setModalxStyle,
} from "./modalx.slice";

export function openPdfPreview(dispatch: Dispatch, id: string, companyId: string | undefined) {
  dispatch(setModalxComponent("PdfView"));
  dispatch(setModalxStyle("large"));
  dispatch(setModalxComponentProps({ id, companyId }));
}

/** `onSuccess` runs after the viewer has signed (the files list reloads its row). */
export function openClickSign(dispatch: Dispatch, fileId: string, onSuccess?: () => void) {
  dispatch(setModalxComponent("ClickToSignConfirm"));
  dispatch(setModalxComponentProps(onSuccess ? { fileId, onSuccess } : { fileId }));
}
